var React = require('react');

function IconPortfolioInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11,0A11,11,0,1,0,22,11,11,11,0,0,0,11,0Zm1.82,14.8L11,16.62a3.33,3.33,0,0,1-4.71-4.71L7.19,11a.67.67,0,0,1,1,.95l-.92.91a2,2,0,0,0,2.83,2.83l1.83-1.83a2,2,0,0,0-.05-2.78l-.31-.31a.65.65,0,1,1,.91-.92l.31.32A3.28,3.28,0,0,1,12.82,14.8Zm3.75-3.75-1,1a.67.67,0,0,1-1-.94l1-1A2,2,0,0,0,12.8,7.28L10.93,9.15a2,2,0,0,0,0,2.81l.31.32a.64.64,0,0,1,0,.93.66.66,0,0,1-.94,0L10,12.9a3.32,3.32,0,0,1,0-4.7l1.87-1.86a3.33,3.33,0,0,1,4.72,4.71Z"}));
}

IconPortfolioInline.defaultProps = {"id":"f5515df1-44fb-4491-bbbf-ed9000c388de","data-name":"Layer 1","viewBox":"0 0 22 22"};

module.exports = IconPortfolioInline;

IconPortfolioInline.default = IconPortfolioInline;
